import React, { useContext } from "react";
import { ThemeContext } from "../theme";

const ContactSupport = () => {
    const { colors } = useContext(ThemeContext)!;

    return (
        <section className={`min-h-screen ${colors.bgSecondaryColor} px-6 py-4 md:py-16`}>
            <div className="mx-auto max-w-6xl">
                {/* Header */}
                <div className="mb-14 text-center">
                    <h1 className={`text-4xl font-bold ${colors.textColor}`}>
                        Contact & Support
                    </h1>
                    <p className={`mt-4 ${colors.textColor} opacity-70 max-w-xl mx-auto`}>
                        Need help, have feedback, or something isn’t working right?
                        Our support team is here to help you move forward.
                    </p>
                </div>

                <div className="grid gap-10 lg:grid-cols-2">
                    {/* Contact Form */}
                    <div
                        className={`${colors.cardBg} ${colors.borderColor} border rounded-2xl p-8 shadow-lg`}
                    >
                        <h2 className={`text-2xl font-semibold ${colors.textColor} mb-6`}>
                            Send us a message
                        </h2>

                        <form className="space-y-5">
                            <div>
                                <label className={`block text-sm font-medium ${colors.textColor}`}>
                                    Full name
                                </label>
                                <input
                                    type="text"
                                    placeholder="John Doe"
                                    className={`mt-2 w-full rounded-lg border ${colors.borderColor} bg-transparent px-4 py-3 ${colors.textColor} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                />
                            </div>

                            <div>
                                <label className={`block text-sm font-medium ${colors.textColor}`}>
                                    Email address
                                </label>
                                <input
                                    type="email"
                                    placeholder="you@example.com"
                                    className={`mt-2 w-full rounded-lg border ${colors.borderColor} bg-transparent px-4 py-3 ${colors.textColor} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                />
                            </div>

                            <div>
                                <label className={`block text-sm font-medium ${colors.textColor}`}>
                                    Subject
                                </label>
                                <select
                                    className={`mt-2 w-full rounded-lg border ${colors.borderColor} bg-transparent px-4 py-3 ${colors.textColor} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                >
                                    <option>General inquiry</option>
                                    <option>Technical support</option>
                                    <option>Billing issue</option>
                                    <option>Feedback & suggestions</option>
                                </select>
                            </div>

                            <div>
                                <label className={`block text-sm font-medium ${colors.textColor}`}>
                                    Message
                                </label>
                                <textarea
                                    rows={5}
                                    placeholder="Tell us what’s going on..."
                                    className={`mt-2 w-full rounded-lg border ${colors.borderColor} bg-transparent px-4 py-3 ${colors.textColor} focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                />
                            </div>

                            <button
                                type="submit"
                                className="w-full rounded-xl bg-blue-600 px-6 py-3 text-white font-medium hover:bg-blue-700 transition"
                            >
                                Send message
                            </button>
                        </form>
                    </div>

                    {/* Support Info */}
                    <div className="space-y-6">
                        <div
                            className={`${colors.cardBg} ${colors.borderColor} border rounded-2xl p-8 shadow-lg`}
                        >
                            <h3 className={`text-xl font-semibold ${colors.textColor} mb-3`}>
                                Support channels
                            </h3>
                            <ul className={`${colors.textColor} opacity-70 space-y-3`}>
                                <li>
                                    📧 <span className="font-medium">Email:</span>{" "}
                                    support@yourdomain.app
                                </li>
                                <li>
                                    🕒 <span className="font-medium">Response time:</span>{" "}
                                    Within 24–48 hours
                                </li>
                                <li>
                                    🌍 <span className="font-medium">Availability:</span>{" "}
                                    Monday – Friday
                                </li>
                            </ul>
                        </div>

                        {/* Highlight box */}
                        <div className="rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-600 p-8 text-white shadow-lg">
                            <h3 className="text-xl font-semibold mb-3">
                                Need quicker answers?
                            </h3>
                            <p className="opacity-90 mb-6">
                                Check our FAQs or Community Guidelines for instant help on common questions.
                            </p>
                            <div className="flex gap-4">
                                <a
                                    href="/faqs"
                                    className="rounded-lg bg-white/10 px-5 py-3 hover:bg-white/20 transition"
                                >
                                    View FAQs
                                </a>
                                <a
                                    href="/community-guidelines"
                                    className="rounded-lg bg-white/10 px-5 py-3 hover:bg-white/20 transition"
                                >
                                    Community Rules
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSupport;
